import React, { useEffect, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Grid, Button, TextField } from '@mui/material';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import { getEligibility } from '../../Utils/api';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import { updateCustomerDetails, updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';

export default function IncomeDetails() {
    const [empType, setempType] = useState(0);
    const [salMode, setsalMode] = useState(0);
    const [pincode, setPincode] = useState('');
    const [dob, setDob] = useState(null);
    const [loader, setLoader] = useState(false);


    const dispatch = useDispatch();
    const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);

    // Pre-fill input fields from Redux
    useEffect(() => {
        if (customerDetails) {
            setempType(customerDetails.income_type_id);
            setsalMode(customerDetails.salary_mode_id);
            setPincode(customerDetails.residence_pincode || '');
            setDob(customerDetails.dob ? new Date(customerDetails.dob) : null);

        }
    }, [customerDetails]);

    const submit = async () => {
        if (loader) return;
        if (!pincode || !dob) {
            toast.error('Please fill all required fields');
            return;
        }

        const param = {
            profile_id: customerDetails?.profileId,
            pancard: customerDetails?.pancard,
            monthly_income: Number(customerDetails?.monthly_income),
            pincode: Number(pincode),
            dob: format(dob, 'dd-MM-yyyy'),
            sourceId: 4,
            income_type_id: empType,
            salary_mode_id: salMode,
            event_name: "register_now",
            salary_date: new Date().toISOString().split('T')[0]
        };

        try {
            setLoader(true);
            const response = await getEligibility(param);
            if (response?.data?.status == 1) {
                toast.success(response?.data?.message);
                dispatch(updateCustomerDetails({
                    dob: dob,
                    residence_pincode: pincode,
                    income_type_id: empType,
                    salary_mode_id: salMode

                }));
                dispatch(updateJourneyEvents({
                    check_eligibility: 1,
                    loan_quote: 2,

                }))

            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error("Error in CheckEligibility");
        } finally {
            setLoader(false);
        }
    };

    return (
        <div className='income-details-wrap'>
            <div className='d-flex align-items-center gap-2 pt-4'>
                <div className='bor rounded-circle'>
                    <ArrowForwardIosIcon style={{ fontSize: '30px', color: '#9a141a' }} />
                </div>
                <h4 className='pl-5 fontstyle'>Income Details</h4>
            </div>

            <div className='pl-45'>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <FormControl>
                                <FormLabel className='label-text fontstyle fw-medium'>
                                    Select Employment Type <span className='text-danger'>*</span>
                                </FormLabel>
                                <RadioGroup value={empType} onChange={(e) => setempType(Number(e.target.value))}>
                                    <Grid container>
                                        <Grid><FormControlLabel value={1} control={<Radio />} label="Salaried" /></Grid>
                                        <Grid><FormControlLabel value={2} control={<Radio />} label="Self-Employed" /></Grid>
                                    </Grid>
                                </RadioGroup>
                            </FormControl>

                            <div className='pt-2'>
                                <p className='mb-0 pb-1 fw-medium fs-6 fontstyle'>Date of Birth <span className='text-danger'>*</span></p>
                                {/* <DatePicker
                                label="Date of Birth"
                                value={dob}
                                onChange={(newValue) => {
                                    if (!customerDetails?.dob) {
                                        setDob(newValue);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        sx={{ maxWidth: 200 }}
                                        disabled={!!customerDetails?.dob} // Disable input if DOB exists
                                    />
                                )}
                                inputFormat="dd/MM/yyyy"
                            /> */}
                                <DatePicker
                                    label="Date of Birth"
                                    value={dob}
                                    onChange={(newValue) => {
                                        setDob(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            sx={{ maxWidth: 200 }}
                                        />
                                    )}
                                    inputFormat="dd/MM/yyyy"
                                />

                            </div>


                        </div>

                        <div className='col-lg-6'>
                            <FormControl>
                                <FormLabel className='label-text fontstyle fw-medium'>
                                    Mode of Salary Received <span className='text-danger'>*</span>
                                </FormLabel>
                                <RadioGroup value={salMode} onChange={(e) => setsalMode(Number(e.target.value))}>
                                    <Grid container>
                                        <Grid><FormControlLabel value={1} control={<Radio />} label="Bank" /></Grid>
                                        {/* <Grid><FormControlLabel value={2} control={<Radio />} label="Cheque" /></Grid> */}
                                        <Grid><FormControlLabel value={3} control={<Radio />} label="Cash" /></Grid>
                                    </Grid>
                                </RadioGroup>
                            </FormControl>

                            <div className='pt-2'>
                                <p className='mb-0 pb-1 fw-medium fs-6 fontstyle'>Pin Code <span className='text-danger'>*</span></p>
                                <div className="input-group mb-3">
                                    <input
                                        type="text"
                                        placeholder="Pincode"
                                        className="form-control solid-border"
                                        style={{ maxWidth: '150px', height: '55px' }}
                                        value={pincode}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Allow only numeric values (0-9) and up to 6 digits
                                            if (/^\d{0,6}$/.test(value)) {
                                                setPincode(value);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            // Block special characters, allow only digits, backspace, delete, arrow keys
                                            const allowedKeys = [
                                                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
                                            ];
                                            if (
                                                !/^\d$/.test(e.key) &&
                                                !allowedKeys.includes(e.key)
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            // Prevent pasting non-numeric or long values
                                            const pasteData = e.clipboardData.getData('Text');
                                            if (!/^\d{1,6}$/.test(pasteData)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />

                                </div>
                            </div>



                        </div>

                    </div>
                </LocalizationProvider>

                <Button
                    variant='contained'
                    className='mt-4'
                    size='large'
                    onClick={submit}
                    style={{ background: '#9a141a' }}
                    disabled={loader} // disable while loading
                >
                    <LibraryAddCheckIcon /> &nbsp;
                    {loader ? 'Checking...' : 'Check Eligibility'}
                </Button>

            </div>
        </div>
    );
}
